export default {
  "Audio Compressor": "Compresseur d'audio",
  "HitPaw Online Audio Compressor": "HitPaw Compresseur d'audio en ligne",
  "Reduce audio file size online without quality loss.": "Réduit la taille du fichier audio en ligne sans perte de qualité.",
  "Compress": "Compresser",
  "Compressing": "Compression",
  "Compressed Successfully": "Compressé avec succès",
  "Compress New": "Compresser à nouveau",
  "Compression is complete": "La compression est complète",
  "Compression failed": "La compression a échoué",
  "Quality": "Qualité",
  "Format": "Format",
  "Add file": "Ajouter un fichier",
  "Output Settings": "Paramètres de sortie",

};
